import { Redirect } from "expo-router";

export default function LegacyAdminRedirect() {
  return <Redirect href={"/admin" as never} />;
}
